// глобальные экшены, в отдельном файле чтобы не было циркулярного импорта
export const INIT = 'playgrounds/app/init';
